module.exports = __webpack_public_path__ + "img/job-white-collar.39b61830.svg";